export const theme = {
  colors: {
    primary: '#3498db',
    secondary: '#2c3e50',
    success: '#2ecc71',
    danger: '#e74c3c',
    warning: '#f1c40f',
    info: '#3498db',
    light: '#f8f9fa',
    dark: '#2c3e50'
  },
  text: {
    primary: '#2c3e50',
    secondary: '#666666',
    light: '#999999'
  },
  background: {
    primary: '#ffffff',
    secondary: '#f8f9fa',
    light: '#ffffff'
  },
  border: {
    color: '#eeeeee',
    radius: '8px'
  },
  shadow: {
    small: '0 2px 4px rgba(0,0,0,0.1)',
    medium: '0 4px 6px rgba(0,0,0,0.1)',
    large: '0 8px 16px rgba(0,0,0,0.1)'
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem'
  },
  typography: {
    fontFamily: {
      primary: "'Arial', sans-serif",
      secondary: "'Product Sans', sans-serif"
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xxl: '1.5rem',
      xxxl: '2rem'
    }
  }
}; 